export enum ButtonType {
  normal = "normal",
  small = "small",
  large = "large",
  text = "text",
  outline = "outline",
}

export enum ButtonColorScheme {
  primary = "primary",
  dark = "dark",
  accent = "accent",
  default = "default",
  gradient = "gradient",
  danger = "danger",
  disabled = "disabled",
}
